<template>
  <div class="content ht-100v pd-0">
    <div class="content-body pd-10">
      <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item">
                <router-link to="#">Attendances</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">All Attendances</li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">View All Attendances</h4>
          <p class="tx-color-03 tx-12 mg-b-0">{{auth.userInfo.firstName}} {{auth.userInfo.lastName}}</p>
          <!--                    <p class="tx-color-03 tx-12 mg-b-0"><strong>Last login:</strong> {{auth.userInfo.userLastLoginDate | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</p>-->
        </div>
        <div class="d-none d-md-block">
          <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5" @click="showModal = !showModal"><plus-icon class="wd-10 mg-r-5" /> Add Attendance</button>
          <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5" @click="showModalQr = !showModalQr"><b-icon-upc-scan class="wd-10 mg-r-5" /> Generate QR</button>
          <download-excel
              :data="attendances"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadExcel')}}
          </download-excel>
          <download-excel
              type="csv"
              :data="attendances"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadCsv')}}
          </download-excel>

        </div>
      </div>
      <base-top-cards :carditems="cards"/>
      <hr>

      <base-table
          :items="attendances"
          :fields="fields"
          :show-title="true"
          :is-busy="attendance.attendanceLoading"
          class="mt-2"
          filter-mode="balances"
      ></base-table>
    </div>
    <create-attendance-modal :show="showModal" :row="{}"/>
    <create-qr-code-modal :show="showModalQr" :row="{}"/>
  </div>
</template>

<script>
import BaseTopCards from "../../components/card/BaseTopCards";
import CreateAttendanceModal from "@/components/modal/CreateAttendanceModal";
import CreateQrCodeModal from "@/components/modal/CreateQrCodeModal";
import BaseTable from "../../components/table/BaseTable";
// import BaseButton from "../../components/button/BaseButton";
import { PrinterIcon, PlusIcon } from 'vue-feather-icons'
import {mapState} from 'vuex'

export default {
  name: 'Loan',
  data() {
    return {
      showModal:true,
      showModalQr:true,
      model:{
        attendanceCode: '',
        attendanceEmployerId: '',
        attendanceGroup: 'DEFAULT',
        attendanceHeadId: "",
        attendanceName: ''
      }
      ,
      fields: [
        { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
        { key: 'employeeFirstName', label: 'First Name', sortable: true, sortDirection: 'desc' },
        { key: 'employeeLastName', label: 'Last Name', sortable: true, class: 'text-left' },
        { key: 'attendanceDate', label: 'Attendance Date', sortable: true, class: 'text-left' },
        { key: 'attendanceStatus', label: 'Status', sortable: true, class: 'text-left' },
        { key: 'attendanceCreatedAt', label: 'Captured Date', sortable: true, class: 'text-left' },
        { key: 'actionsAttendance', label: 'Action', sortable: true, class: 'text-center' }
      ],
    }
  },
  components: {
    PlusIcon,
    CreateQrCodeModal,
    BaseTable,
    BaseTopCards,
    PrinterIcon,
    CreateAttendanceModal,
  },
  computed: {
    cards:{
      get(){
        return [
          {
            id: 0,
            name: 'Total Attendances',
            number: this.attendances.length,// == null?'0.00':'GHS '+this.numberWithCommas(this.totalGhs),
            color: 'bg-primary'
          },
          {
            id: 1,
            name: 'Approved Attendances',
            number: this.attendances.filter(it => it.attendanceStatus.toUpperCase() === 'APPROVED').length,// == null?'0.00':'GBP '+this.numberWithCommas(this.totalGbp),
            color: 'bg-orange'
          },
          {
            id: 2,
            name: 'Pending Attendances',
            number: this.attendances.filter(it => it.attendanceStatus.toUpperCase() === 'PENDING').length,// == null?'0.00':'USD '+this.numberWithCommas(this.totalUsd),
            color: 'bg-success'
          },
          {
            id: 3,
            name: 'Declined Attendances',
            number: this.attendances.filter(it => it.attendanceStatus.toUpperCase() === 'DECLINED').length,// == null?'0.00':'EUR '+this.numberWithCommas(this.totalEur),
            color: 'bg-black-8'
          }
        ]
      },
      set(){

      }
    },
    attendances(){
      return  this.attendance.attendanceByEmployer.data
    },
    authobj: function () {
      return this.$store.state.auth.response
    },
    employees(){
      return  this.employee.employees?this.employee.employees:[]
    },
    ...mapState([
      'employee',
      'attendance',
      'auth'
    ])
  },
  methods: {
    async createAttendance(){
      this.model.attendanceEmployerId = localStorage.orgId
      await this.$store.dispatch("attendance/createAttendance", this.model, {root: false})
      this.loadAttendance();
      this.hide();
      let self = this;
      // eslint-disable-next-line no-unused-vars
      Object.keys(this.model).forEach(function(key,index) {
        self.model[key] = '';
      });

    },
    loadAttendance(){
      this.$store.dispatch("attendance/updateAttendances", {
        readAll:'NO',
        employerId: localStorage.orgId
      }, {root: false}).then()
    },
    hide() {
      this.$refs['attendance-modal'].hide()
    },
    numberWithCommas(x) {
      let parts = x.toString().split(".");
      if (parts[1] == null)  parts[1] = '00'
      else if (parts[1].length === 0) parts[1] = parts[1]+'00'
      else if (parts[1].length === 1) parts[1] = parts[1]+'0'
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  created() {
    this.$store.dispatch("attendance/updateAttendanceByEmployer", {
      readAll:'NO',
      employerId: localStorage.orgId
    }, {root: false}).then()
  }
}


</script>

<style scoped>

</style>
